import React, { useState } from "react";
import Resume from '../Assets/RESUME.pdf'
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';


function Nav(props) {
  const [screen, setScreen] = useState(false);
  const [hide,setHide] = useState(true)

  window.addEventListener("scroll", () => {
    if (window.scrollY > 100) {
      setScreen(true);
    } else {
      setScreen(false);
    }
  });
  return (
    <>
      <helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;700&family=Oswald:wght@700&display=swap"
          rel="stylesheet"
        />
      </helmet>
      <MenuIcon id="menu" onClick={() => { setHide(false) }} />
      <nav
        
        style={{
          position:
            screen && window.screen.width > 600
              ? "fixed"
              : window.screen.width <= 600
              ? "fixed"
              : "",
          backgroundColor:
            screen && window.screen.width > 600
              ? "rgba(12, 144, 184, 0.223)"
              : "",
        }}

        id={ window.screen.width <= 600 && !hide && "navshow"}
      >
        <CloseIcon id="close" onClick={()=> setHide(true) } />
        <section className="logo">
          Coding Ba<sup>Gh</sup>.
        </section>
        <ul>
          <a href="#Home" onClick={()=> setHide(true) } >Home</a>
          <a href="#Services" onClick={()=> setHide(true) } >Services</a>
          <a href="#Works" onClick={()=> setHide(true) } >Projects</a>
          <a href="#About" onClick={()=> setHide(true) } >About Me</a>
          <a href="#skills" onClick={()=> setHide(true) } >Skill</a>
          <a href="#contact" onClick={()=> setHide(true) } >Contact</a>

          <a href={Resume} className="btn" target="_blank" rel="noreferrer">
            Resume
          </a>
        </ul>
      </nav>
    </>
  );
}

export default Nav;
